import { Card, CardContent } from "@/components/ui/card";
import { Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "Since joining, my business has grown, and I've formed relationships that go beyond just referrals - they're true partnerships.",
      author: "Katie Jackson",
      title: "Founder of Fuel for Impact"
    },
    {
      quote: "The referral connection network group has been a great resource to connect with other business professionals in the area. It is nice to have a place to meet with people in person to share wins, losses and laughs with.",
      author: "Eric McCleave",
      title: "Owner EWM Solutions"
    }
  ];

  return (
    <section id="members" className="py-20 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-foreground mb-4 animate-fade-in">
            What Our Members Say
          </h2>
          <p className="text-lg text-muted-foreground animate-fade-in" style={{ animationDelay: "0.2s" }}>
            Discover how our community empowers businesses through collaboration and referrals.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="hover:shadow-xl transition-shadow animate-fade-in" style={{ animationDelay: `${0.3 + index * 0.1}s` }}>
              <CardContent className="p-8">
                <Quote className="h-10 w-10 text-primary/20 mb-4" />
                <p className="text-lg text-foreground mb-6 italic">
                  "{testimonial.quote}"
                </p>
                <div>
                  <p className="font-semibold text-foreground">{testimonial.author}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.title}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
